'use client';

import { PropsWithChildren, ReactNode, useContext, useMemo } from 'react';

import { FiltersContext } from './FiltersProvider';

export const FiltersStateLoader = ({
  children,
  fallback,
}: PropsWithChildren<{ fallback?: ReactNode }>) => {
  const [filtersState] = useContext(FiltersContext);

  const isEmptyState = useMemo(() => {
    if (!filtersState) {
      return true;
    }

    return !Object.values(filtersState).length;
  }, [filtersState]);

  if (isEmptyState) {
    return fallback;
  }
  return children;
};
